import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom/cjs/react-router-dom.min";

export const MenuItems = ({
  open,
  items,
  key,
  setShowAnotherDiv,
  handleMouseLeave,
  showAnotherDiv,
  hoveredItem,
}) => {
  const location = useLocation();
  return (
    <>
      {items.path === "/dashboard/choiceTable" ? (
        <>
          <div
            key={key}
            onClick={() => setShowAnotherDiv(items)}
            className={`flex gap-[8px] items-center cursor-pointer border-r border-[#D9D9D9] mr-[-1px] ${
              location.pathname == items.path
                ? "bg-[#FFEEE5] text-[#F46C3C]"
                : ""
            } ${open ? "justify-start" : "justify-center"} py-[8px] ${
              open ? "px-[16px]" : " "
            } ${
              showAnotherDiv && hoveredItem?.name === items?.name
                ? "bg-[#F0F0F0]"
                : ""
            } hover:bg-[#F0F0F0]`}
          >
            <div className="w-[24px] h-[24px]  flex justify-center items-center">
              <div
                dangerouslySetInnerHTML={{ __html: items.icon }}
                className={`${
                  location.pathname == items.path ? "active-svg" : ""
                }`}
              />
            </div>
            {open && (
              <p className="text-[14px] group:hover:text-[#F46C3C] font-medium">
                {items.name}
              </p>
            )}
          </div>
        </>
      ) : items.path === null ? (
        <div
          key={key}
          onmouse
          onClick={() => setShowAnotherDiv(items)}
          // onMouseLeave={() => handleMouseLeave()}
          className={`flex gap-[8px] items-center cursor-pointer border-r border-[#D9D9D9] mr-[-1px] ${
            location.pathname.includes(items.pathName.toLowerCase())
              ? "bg-[#FFEEE5] text-[#F46C3C]"
              : ""
          }
          ${
            showAnotherDiv && hoveredItem?.name === items?.name
              ? "bg-[#F0F0F0]"
              : ""
          } ${
            location.pathname == items.pathName
              ? "bg-[#FFEEE5] text-[#F46C3C]"
              : ""
          } ${open ? "justify-start" : "justify-center"} py-[8px] ${
            open ? "px-[16px]" : " "
          } hover:bg-[#F0F0F0]`}
        >
          <div className="w-[24px] h-[24px]  flex justify-center items-center">
            <div
              dangerouslySetInnerHTML={{ __html: items.icon }}
              className={`${
                location.pathname.includes(items.pathName.toLowerCase())
                  ? "active-svg"
                  : ""
              }`}
            />
          </div>
          {open && (
            <p className="text-[14px] group:hover:text-[#F46C3C] font-medium">
              {items.name}
            </p>
          )}
        </div>
      ) : (
        <NavLink
          to={items.path}
          key={key}
          onClick={handleMouseLeave}
          className={`flex gap-[8px]
                ${
                  location.pathname == items.path.toLowerCase()
                    ? "bg-[#FFEEE5] text-[#F46C3C]"
                    : ""
                }
                items-center cursor-pointer border-r border-[#D9D9D9] mr-[-1px] ${
                  open ? "justify-start" : "justify-center"
                } py-[8px] ${open ? "px-[16px]" : " "} hover:bg-[#F0F0F0]`}
        >
          <div
            className={`w-[24px] h-[24px]  flex justify-center items-center ${
              items.path == "/dashboard/faq" ? "faqs-svg" : ""
            }`}
          >
            <div
              dangerouslySetInnerHTML={{ __html: items.icon }}
              className={`${
                location.pathname == items.path ? "active-svg" : ""
              }`}
            />
          </div>
          {open && (
            <p className="text-[14px] group:hover:text-[#F46C3C] font-medium">
              {items.name}
            </p>
          )}
        </NavLink>
      )}
    </>
  );
};
